import {
  Datagrid,
  Filter,
  FunctionField,
  List,
  ListProps,
  SearchInput,
  SelectInput,
  TextField,
  useDataProvider,
} from "react-admin";
import { Helmet } from "react-helmet";
import CustomPriceField from "../../components/CustomPriceField";
import ShowInvoicePdfButton from "./components/ShowInvoicePdfButton";
import { InvoiceStatusFilterList } from "./conts";

const InvoiceFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
    <SelectInput source="Status" choices={InvoiceStatusFilterList} alwaysOn />
  </Filter>
);

const InvoiceList = (props: ListProps) => {
  const provider = useDataProvider();

  return (
    <>
      <Helmet>
        <title>Invoices</title>
      </Helmet>

      <List
        exporter={false}
        hasCreate={false}
        actions={null}
        filters={<InvoiceFilter />}
        sort={{ field: "createdAt", order: "DESC" }}
        bulkActionButtons={false}
        {...props}
      >
        <Datagrid>
          <TextField label="Invoice Number" source="number" emptyText="-" />
          <TextField label="Type Invoice" source="label" emptyText="-" />
          <TextField
            label="Description"
            source="items[0].description"
            emptyText="-"
          />
          <CustomPriceField label="Amount" source="subTotal" />
          <CustomPriceField label="Amt. Include VAT" source="total" />

          <TextField label="Status" source="status" />

          <FunctionField
            label="Action"
            render={(record: any) => {
              return (
                <>
                  {record.status === "posted" && (
                    <ShowInvoicePdfButton
                      invoiceId={Number(record.id)}
                      invoiceNumber={record.number}
                      pdfUrl={record.pdfUrl}
                      provider={provider}
                    />
                  )}
                </>
              );
            }}
          />
        </Datagrid>
      </List>
    </>
  );
};
export default InvoiceList;
